"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pRateLimit = void 0;
var dequeue_1 = require("./dequeue");
var quotaManager_1 = require("./quota/quotaManager");
var rateLimitTimeoutError_1 = require("./rateLimitTimeoutError");
function pRateLimit(quotaManager) {
  if (!(quotaManager instanceof quotaManager_1.QuotaManager)) {
    return pRateLimit(new quotaManager_1.QuotaManager(quotaManager));
  }
  var queue = new dequeue_1.Dequeue();
  var timerId = null;
  var next = function next() {
    while (queue.length && quotaManager.start()) {
      queue.shift()();
    }
    if (queue.length && !quotaManager.activeCount && !timerId) {
      timerId = setTimeout(function () {
        timerId = null;
        next();
      }, 100);
    }
  };
  return function (fn) {
    return new Promise(function (resolve, reject) {
      var timerId = null;
      if (quotaManager.maxDelay) {
        timerId = setTimeout(function () {
          timerId = null;
          reject(new rateLimitTimeoutError_1.RateLimitTimeoutError('queue maxDelay timeout exceeded'));
          next();
        }, quotaManager.maxDelay);
      }
      var run = function run() {
        if (quotaManager.maxDelay) {
          if (timerId) {
            clearTimeout(timerId);
          } else {
            // timeout already fired
            return;
          }
        }
        fn().then(function (val) {
          quotaManager.end();
          resolve(val);
        }).catch(function (err) {
          quotaManager.end();
          reject(err);
        }).then(function () {
          next();
        });
      };
      queue.push(run);
      next();
    });
  };
}
exports.pRateLimit = pRateLimit;